module.exports = __webpack_public_path__ + "static/media/ic_award.ce5b4b2c.svg";